module.exports = __webpack_public_path__ + "static/media/Manufactures-limited-warranty-badge.904ea27a.svg";